<template>
  <div id="app">
    <!-- Start Top Bar -->
    <header class="global-header site-header__top">
      <div class="top-bar container">
        <div class="top-bar-left">
          <ul class="menu">
            <li>
              <!-- トップページだけ h1 -->
              <h1 v-if="isHome" class="brand brand--h1">
                <router-link :to="{ name: 'Index'}" aria-current="page" class="brand__link">
                  <img class="header-logo" src="/images/large_logo.svg" aria-hidden="true" alt="">
                  <span class="sr-only">BOATNAVI報知（ボートレース専門サイト）</span>
                </router-link>
              </h1>

              <!-- それ以外は div（見た目は同じ） -->
              <div v-else class="brand">
                <router-link :to="{ name: 'Index'}" class="brand__link">
                  <img class="header-logo" src="/images/large_logo.svg" aria-hidden="true" alt="">
                  <span class="sr-only">BOATNAVI報知（ボートレース専門サイト）</span>
                </router-link>
              </div>
            </li>
          </ul>
        </div>

        <!-- 右側：ログイン or ユーザーメニュー（Nuxt版と同デザイン） -->
        <div class="top-bar-right">
          <!-- 未ログイン -->
          <router-link
            v-if="$store.getters.user == null"
            :to="{ name: 'UserLogin'}"
            class="login-btn"
          >
            <span>ログイン</span>
          </router-link>

          <!-- ログイン時 -->
          <div
            v-else
            class="user has-dd"
            @mouseleave="menuOpen=false"
            @keydown.esc="menuOpen=false"
          >
            <button
              ref="chip"
              class="user-chip"
              type="button"
              @click="toggleMenu"
              :aria-expanded="menuOpen ? 'true' : 'false'"
              aria-haspopup="menu"
            >
              <img class="user-icon" src="/images/icon_login.svg" alt="">
              <span class="user-name">
                {{ $store.getters.user.nickname }}さん
                <span class="caret" aria-hidden="true"></span>
              </span>
            </button>

            <ul
              class="dropdown"
              role="menu"
              :class="{ 'is-open': menuOpen }"
            >
              <li role="none">
                <router-link role="menuitem" class="dd-link" :to="{ name: 'UserMyPage'}">マイページ</router-link>
              </li>
              <li role="none">
                <router-link
                    :to="{ name: 'UserLogin', query: { logout: '1', return: $route.fullPath } }"
                    role="menuitem"
                    class="dd-link"
                  >
                    ログアウト
                  </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- 下段：グローバルナビ（既存のまま） -->
      <nav class="global-nav" aria-label="グローバルナビゲーション">
        <div class="container">
          <ul class="global-nav__list" role="menubar">
            <li role="none">
              <router-link :to="{name:'Index'}" class="link" exact-active-class="is-current" role="menuitem">ホーム</router-link>
            </li>

            <li role="none">
              <router-link :to="{name:'DayRaceList',params:{date:date_str}}" class="link" exact-active-class="is-current" role="menuitem">本日のレース</router-link>
            </li>

            <li role="none">
              <router-link :to="{name: 'RacerRanking',params:{kbn:'all'} }" class="link" exact-active-class="is-current" role="menuitem">賞金ランキング</router-link>
            </li>

            <li role="none">
              <a href="/articles" class="link" role="menuitem">ニュース</a>
            </li>
       
          </ul>
        </div>
      </nav>
    </header>
    <!-- End Top Bar -->

    <div class="main-wrapper site-main">
      <div class="site-main__inner">
        <div :class="['site-main__grid', { 'has-aside': hasAside }]">
          <section class="site-content">
            <router-view></router-view>
          </section>

          <!-- 右カラム（ルートに aside ビューがあれば表示） -->
          <aside v-if="hasAside" class="site-aside">
            <router-view name="aside"></router-view>
          </aside>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <footer class="callout large global-footer site-footer">
      <div class="container">
        <nav class="footer-nav" aria-label="フッターナビゲーション">
          <ul class="footer-nav__list">
            <li><a href="https://www.hochi.co.jp/policy/" target="_blank">サイトポリシー</a></li>
            <li><a href="https://www.hochi.co.jp/privacy/" target="_blank">個人情報について</a></li>
            <li><router-link :to="{name:'UserdataExternalTransmissionPage'}">データ収集と利用について</router-link></li>
            <li><router-link :to="{name:'HowToPage'}">ボートナビの使い方</router-link></li>
            <li><router-link :to="{name:'KiyakuPage'}">会員規約</router-link></li>
          </ul>
        </nav>

        <p class="copyright">
          見出し、記事、写真の無断転載を禁じます。
          <span>Copyright © 2025 The Hochi Shimbun.</span>
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data () {
    return {
      user: null,
      today_str: '',
      date_str: '',
      menuOpen: false,
    }
  },
  head: {
    title () {
      return {
        inner: 'BOATNAVI報知 - ボートレース専門サイト　ボートナビ報知'
      }
    },
    meta () {
      return [
        { property: 'og:title', content: 'BOATNAVI報知 - ボートレース専門サイト　ボートナビ報知' },
        { property: 'og:description', content: 'スポーツ報知が運営するボートレース専門サイト「ボートナビ報知」。全場、全レースで予想に必須なデータのほか、ＡＩ予想やスポーツ報知が開発した分析データ報知スコープがご覧頂けます。' },
        { name: 'description', content: 'スポーツ報知が運営するボートレース専門サイト「ボートナビ報知」。全場、全レースで予想に必須なデータのほか、ＡＩ予想やスポーツ報知が開発した分析データ報知スコープがご覧頂けます。' }
      ]
    }
  },
  created () {
    this.today = new Date()
    this.date = new Date()
    this.today_str = '' + this.today.getFullYear() + ('0' + (this.today.getMonth() + 1)).slice(-2) + ('0' + this.today.getDate()).slice(-2)
    this.date_str = this.today_str
  },
  mounted () {
    // 画面外クリックでメニューを閉じる
    document.addEventListener('click', this.onDocClick, true)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.onDocClick, true)
  },
  computed: {
    hasAside () {
      return this.$route.matched.some(r => r.components && r.components.aside)
    },
    isHome () {
      return this.$route && (this.$route.name === 'Index' || this.$route.path === '/')
    }
  },
  methods: {
    toggleMenu () {
      this.menuOpen = !this.menuOpen
      if (!this.menuOpen && this.$refs.chip) {
        try { this.$refs.chip.blur() } catch (e) {/* */}
      }
    },
    onDocClick (e) {
      const t = e.target
      if (!t.closest || !t.closest('.user.has-dd')) {
        this.menuOpen = false
      }
    },
    logout () {
      this.$cognito.logout()
      this.$store.commit('setUser', null)
      
   
  // ← これを追加（Cookie消去）
  try{
    document.cookie = `__bn_user_json=; Path=/; Max-Age=0`;
    document.cookie = `__bn_user_json=; Path=/; Domain=.hochi.co.jp; Max-Age=0`;
  }catch(_){/* eslint-disable */}

  if(
    this.$route.name == 'UserMyPage'||
    this.$route.name == 'UserConfirmChEmail'||
    this.$route.name == 'UserChEmail'||
    this.$route.name == 'UserChPassword'||
    this.$route.name == 'UserChAttr'
  ){
    this.$router.replace('/login')
  }
    }
  }
}
</script>

<style lang="scss">
@import "./assets/scss/_settings.scss";
@import "./assets/scss/app.scss";
</style>

<style>
/* ====== 既存の共通 ====== */
.site-header__top .top-bar{ background-color:#FFF; height:56px; }
.site-header__top ul{ background:none; }
.site-header__top .container{ max-width:1280px; margin:0 auto; padding:0 16px; display:flex; align-items:center; height:65px; }

h1.brand--h1 a{ cursor: default; }

/* ログインボタン（共通） */
.site-header__top .login-btn{
  display:inline-flex; align-items:center; justify-content:center;
  padding:10px 18px !important; background:#de5a1a; color:#fff; font-weight:700;
  border-radius:8px; text-decoration:none;
  transition:filter .15s ease, transform .06s ease, box-shadow .15s ease;
  min-height:44px;
}
.site-header__top .login-btn:hover{ filter:brightness(0.96); }
.site-header__top .login-btn:active{ transform:translateY(1px); }
.site-header__top .login-btn:focus-visible{ outline:3px solid #1aa3ff; outline-offset:2px; border-radius:8px; }

/* ====== ここから Nuxt と揃えたユーザー UI ====== */
.top-bar-right{ display:flex; align-items:center; gap:12px; }

/* ユーザーチップ（白ベース） */
.site-header__top .user.has-dd{ position:relative; }
.site-header__top .user-chip{
  display:inline-flex; align-items:center; gap:8px;
  min-height:40px; padding:8px 12px;
  background:#fff; color:#111; font-weight:800; border-radius:999px;
  border:1px solid #e5e7eb; cursor:pointer;
}
.site-header__top .user-chip:hover{ background:#f3f4f6; }
.site-header__top .user-chip:focus-visible{ outline:3px solid #1aa3ff; outline-offset:2px; border-radius:999px; }
.site-header__top .user-icon{ width:18px; height:18px; display:block; }

/* ニックネームの後ろの固定三角 */
.site-header__top .user-name{ display:inline-flex; align-items:center; line-height:1; }
.site-header__top .user-name .caret{
  display:inline-block; width:0; height:0; margin-left:6px;
  border-left:5px solid transparent; border-right:5px solid transparent; border-top:6px solid currentColor;
}

/* ドロップダウン（白ベース） */
.site-header__top .dropdown{
  position:absolute; right:0; top:calc(100% + 8px);
  min-width:180px; margin:0; padding:4px; list-style:none;
  background:#fff; color:#111;
  border:1px solid #e5e7eb; border-radius:10px;
  box-shadow:0 10px 24px rgba(0,0,0,.12);
  opacity:0; visibility:hidden; transform:translateY(8px);
  transition:opacity .15s ease, transform .15s ease, visibility .15s step-end;
  z-index:1000;
}

/* PC：ホバー/フォーカスで開く */
@media (hover:hover) and (pointer:fine){
  .site-header__top .user.has-dd:hover .dropdown,
  .site-header__top .user.has-dd:focus-within .dropdown{
    opacity:1; visibility:visible; transform:translateY(0);
    transition:opacity .15s ease, transform .15s ease, visibility 0s;
  }
}

/* モバイル：クリック開閉 */
.site-header__top .dropdown.is-open{
  opacity:1; visibility:visible; transform:translateY(0);
  transition:opacity .15s ease, transform .15s ease, visibility 0s;
}

.site-header__top .dd-link{
  display:flex; align-items:center; justify-content:flex-start;
  height:44px; padding:0 12px;
  color:inherit; text-decoration:none; font-weight:800;
  border-left:3px solid transparent; border-radius:6px;
}
.site-header__top .dd-link:hover{ background:#f3f4f6; color:inherit; border-left-color:#d1d5db; }
.site-header__top .dd-link:focus-visible{ outline:3px solid #1aa3ff; outline-offset:-3px; }

/* ====== グロナビは既存のまま ====== */
.global-nav{ background:#0b2f4a; color:#fff; border-bottom:1px solid rgba(255,255,255,.25); }
.global-nav{ --gn-item-w:160px; }
@media (min-width:1440px){ .global-nav{ --gn-item-w:176px; } }
@media (min-width:1024px) and (max-width:1279px){ .global-nav{ --gn-item-w:148px; } }
.global-nav .container{ height:56px; display:flex; align-items:center; }
.global-nav__list{ list-style:none; margin:0; padding:0; height:100%; display:flex; align-items:stretch; gap:8px; justify-content:flex-start; flex-wrap:nowrap; }
.global-nav__list > li{ list-style:none; margin:0; padding:0; position:relative; flex:0 0 var(--gn-item-w); }
.global-nav .link{
  width:100%; height:56px; padding:0 12px;
  display:flex; align-items:center; justify-content:center;
  color:#fff; text-decoration:none; font-weight:800;
  border-bottom:3px solid transparent; font-size:15px; line-height:1;
  white-space:nowrap; text-overflow:ellipsis; overflow:hidden;
  transition:background-color .15s ease, border-color .15s ease, color .15s ease, transform .06s ease;
}
.global-nav .link:hover{ background:#103a5c; }
.global-nav .link.is-current{ border-bottom-color:#fff; }
.global-nav .link:focus-visible{ outline:none; box-shadow:0 0 0 3px #ffffffaa inset; border-radius:4px; }
.global-nav .link:active{ transform:translateY(1px); }

/* モバイル最適化 */
@media (max-width:767px){
  .site-header__top .container{ height:56px !important; }
  .site-header__top .global-nav .container{ height:48px !important; }
  .brand img{ height:28px; }
  .global-nav .container{ height:48px; }
  .global-nav__list{ gap:6px; overflow-x:auto; -webkit-overflow-scrolling:touch; scrollbar-width:none; }
  .global-nav__list::-webkit-scrollbar{ display:none; }
  .global-nav__list > li{ flex:0 0 auto; }
  .global-nav .link{ height:48px; padding:0 10px; font-size:13px; }
  .global-nav__list > li > .dropdown{ display:none !important; }
  .dd-link{ height:48px; padding:0 10px; font-size:13px; }
}

/* ====== メイン/フッター（既存） ====== */
.site-footer{ background:#0b2f4a; color:#fff; border-top:1px solid rgba(255,255,255,.15); padding:56px 0 84px; margin-top:100px; }
.site-footer .container{ max-width:1280px; margin:0 auto; padding:0 16px; }
.footer-nav__list{ list-style:none; margin:0 0 18px; padding:0; display:flex; justify-content:center; align-items:center; flex-wrap:wrap; }
.footer-nav__list > li{ position:relative; padding:0 18px; margin:6px 0; }
.footer-nav__list > li + li::before{ content:""; position:absolute; left:0; top:50%; width:1px; height:1.1em; transform:translateY(-50%); background:rgba(255,255,255,.45); }
.footer-nav__list a{ color:#fff; text-decoration:none; font-weight:700; font-size:14px; letter-spacing:.02em; transition:opacity .15s ease, text-decoration-color .15s ease; }
@media (hover:hover){ .footer-nav__list a:hover{ opacity:.9; text-decoration:underline; text-underline-offset:3px; } }
.footer-nav__list a:focus-visible{ outline:3px solid #1aa3ff; outline-offset:2px; border-radius:6px; }
.copyright{ text-align:center; color:#d1d5db; font-size:13px; margin:0; line-height:1.7; }
.copyright span{ white-space:nowrap; }
@media (max-width:640px){
  .site-footer{ padding:28px 0 36px; }
  .footer-nav__list > li{ padding:0 12px; }
  .footer-nav__list a{ font-size:13px; }
  .copyright{ font-size:12px; }
}

/* 2カラム関連（既存を維持） */
.site-main{ padding:0 0 40px; }
.site-main__inner{ max-width:1280px; margin:0 auto; padding:0 16px; }
.site-main__grid{ display:grid; gap:40px; align-items:start; }
.site-main__grid.has-aside{ grid-template-columns:minmax(0,1fr) 300px; }
.site-aside{ width:300px; box-sizing:content-box; padding:16px 0 0 0; }
@media (max-width:1023px){
  .site-main__grid,
  .site-main__grid.has-aside{ grid-template-columns:1fr; }
  .site-aside{ width:100%; }
  .site-main__inner{ padding:0; }
}
@media (min-width:1024px){ .site-aside{ position:sticky; top:16px; } }
.site-content{ min-width:0; }

/* ロゴ/アクセシビリティ */
.brand{ display:flex; align-items:center; }
.brand--h1{ margin:0; font-size:inherit; font-weight:inherit; line-height:0; }
.brand__link{ display:inline-flex; align-items:center; text-decoration:none; }
.header-logo{ display:block; height:32px; }
.sr-only{
  position:absolute!important; width:1px; height:1px; padding:0; margin:-1px;
  overflow:hidden; clip:rect(0,0,0,0); white-space:nowrap; border:0;
}
</style>